import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";
import { useSearchParams } from "react-router-dom";
function My_team_BoosterDetails() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");
  const packages = searchParams.get("package");

  let user = "224466";

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(user);

  const [select, setSelect] = useState("0");
  const [position, setPosition] = useState("0");

  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");
  const [TotalId, setTotalId] = useState(0);
  const [TotalAmount, setTotalAmount] = useState(0);

  //   let value = 2
  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: search,
          report: "myBoosterTeamDetails",
          fdate: formdate,
          tdate: todate,
          status: packages,
          level: uid,
          Position: position,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("My_Team", responceRight?.data?.data[0]);
      console.log("Direct team Output", responceRight?.data?.dataOutput);
      setTotalId(responceRight?.data?.data[0][0]?.totalrecord);
      setTotalAmount(responceRight?.data?.dataOutput?.totalamount);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item?.RowNumber,
          uid: item?.uid,
          dd: item?.dd,

        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "date", accessor: "dd" },

    ],
  });
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Auto Pool Downline Details</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="userid"
                        ng-model="p.userid"
                        class="form-control in-ip-1"
                        placeholder="Enter User Id"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <div class="col-md-2">
                      <select
                        class="form-control in-ip-1"
                        onChange={(e) => setSelect(e.target.value)}
                        id="SelectStatus"
                        name="SelectStatus">
                        <option value={0}>All Pool</option>
                        <option value={1}>Pool 1</option>
                        <option value={2}>Pool 2</option>
                        <option value={3}>Pool 3</option>
                        <option value={4}>Pool 4</option>
                      </select>
                    </div>



                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>

                  <div class="row">

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default My_team_BoosterDetails;
